import bootbox from 'bootbox'

$(() => {
  $('.remove-offer').on('click', function() {
    let url = Routing.generate('api_remove_offer', { id: $(this).data('id') })

    bootbox.confirm({
      message: Translator.trans('form.confirm'),
      buttons: {
        confirm: {
          label: Translator.trans('common.yes'),
        },
        cancel: {
          label:Translator.trans('common.no'),
        }
      },
      callback: function (result) {
        if (result) {
          $.ajax({
            url: url,
            type: 'DELETE',
            success: function () {
              window.toastr.success(Translator.trans('form.removed'))
              location.reload()
            },
            error: function (xhr) {
              if (xhr.status === 423) {
                window.toastr.error(xhr.responseJSON.error)
              } else {
                window.toastr.error(Translator.trans('form.error.removed'))
              }

            }
          })
        }
      }
    })
  })
})
